import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import removeDiactritics from 'common/app/removeDiacritics';
import { isRequired } from 'components/Questionnaires/validators';
import { AutoCompleteField } from '../../../Common/Inputs/AutoCompleteField';

export const QuestionStockMarketAutocompleteField = ({ blockId, question, intl, className, onChange }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const onInputChange = (event, { newValue }) => {
    setInputValue(newValue);
    onChange(question, newValue);
    return true;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  useEffect(() => {
    if (inputValue !== question.answer) {
      setInputValue(question.answer ?? '');
    }
  }, [question.answer]);

  const stockMarkets = useSelector(state => state.app?.staticData?.stockMarkets?.map(s => ({ ...s, searchName: removeDiactritics(s.exchangeName) ?? [] })));

  const getSuggestionValue = s => `${ s.exchangeName } (${ s.mic })`;

  const classNameProp = `${ className }${ question.isValid === false ? ' error' : '' }`;
  const inputProps = {
    key: `${ blockId }-${ question.id }`,
    id: `${ blockId }-${ question.id }`,
    name: question.id,
    value: inputValue,
    onChange: onInputChange,
    onFocus: e => e.target?.select(),
    placeholder: (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '',
    autoComplete: 'off',
    disabled: question.disabled,
    required: isRequired(question),
    type: 'text',
    'aria-label': (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '',
    'aria-required': isRequired(question),
    'aria-describedby': question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined,
    className: classNameProp
  };

  return (
    <AutoCompleteField
      getSuggestionValue={ getSuggestionValue }
      inputProps={ inputProps }
      classNameProp={ classNameProp }
      listToFilter={ stockMarkets }
    />
  );
};

QuestionStockMarketAutocompleteField.propTypes = {
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

QuestionStockMarketAutocompleteField.defaultProps = {
  className: '',
};

export default QuestionStockMarketAutocompleteField;
